<template>
    <dialog-form
        :value="value"
        @input="onInput($event)"
        :title="$localize('CreateApiKey.title')"
        @commit="save"
        :allow-continue="false"
        :action="action"
        :allow-cancel="action === 'save'"
        :persistent="action === 'ok'"
    >
        <v-text-field
            v-if="action === 'save'"
            :label="$localize('ApiKey.name')"
            v-model="createApiKey.name"
            :rules="[validation.required]"
            prepend-icon="mdi-text-short"
        />

        <v-select
            v-if="action === 'save'"
            v-model="createApiKey.expires"
            :rules="[validation.required]"
            :items="expirationOptions"
            :label="$localize('ApiKey.prop.expires')"
            :hint="$localize('Settings.prop.expires.hint')"
            item-value="value"
            item-text="name"
            persistent-hint
            prepend-icon="mdi-calendar-range"
        />
        <select-user
            v-model="createApiKey.userId"
            :label="$localize('ApiKey.user')"
        />
        <div v-if="action === 'ok'">
            <v-alert type="info">
                Dit is je geheime API-sleutel<br />
                Kopieer de sleutel nu. Je kunt hem later niet meer inzien.
            </v-alert>

            <v-row no-gutters>
                <v-col>
                    <v-text-field
                        :value="apiKey"
                        filled
                        label="Api Key"
                        hide-details
                        ref="apiKeyField"
                        readonly
                    />
                </v-col>
                <v-col align-self="center" cols="auto" class="ml-1">
                    <v-btn small outlined fab @click="copyKey">
                        <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </div>
    </dialog-form>
</template>

<script>
import DialogForm from '@/shared/components/DialogForm'
import SelectUser from '@/main/components/forms/SelectUser'
import sendCommand from '@/services/sendCommand'
import { required } from '@/services/validation'
import { showSnackbar } from '@/services/snackbars'

export default {
    components: { DialogForm, SelectUser },
    props: {
        value: Boolean,
    },
    data() {
        return {
            expirationOptions: [
                {
                    name: this.$localize('ApiKey.expires.3months'),
                    value: '3months',
                },
                {
                    name: this.$localize('ApiKey.expires.6months'),
                    value: '6months',
                },
                {
                    name: this.$localize('ApiKey.expires.1year'),
                    value: '1year',
                },
                {
                    name: this.$localize('ApiKey.expires.2years'),
                    value: '2years',
                },
                {
                    name: this.$localize('ApiKey.expires.3years'),
                    value: '3years',
                },
                {
                    name: this.$localize('ApiKey.expires.never'),
                    value: 'never',
                },
            ],
            createApiKey: {},
            validation: { required },

            created: false,
            action: 'save',
            apiKey: null,
        }
    },

    methods: {
        reset() {
            this.created = false
            this.action = 'save'
            this.apiKey = null
            this.createApiKey.name = ''
            this.createApiKey.expires = null
        },
        async save(callback) {
            const result = await sendCommand('CreateApiKey', this.createApiKey)

            if (result.success) {
                this.$emit('saved')
                this.created = true
                this.action = 'ok'
                this.apiKey = result.message
            }
            callback({ success: false })
        },
        copyKey() {
            const apiKeyElement =
                this.$refs.apiKeyField.$el.querySelector('input')
            apiKeyElement.focus()
            apiKeyElement.select()

            let copied
            try {
                copied = document.execCommand('copy')
            } catch (err) {
                copied = false
            }
            if (copied) {
                showSnackbar({
                    text: this.$localize('ApiKey.message.copiedToClipboard'),
                })
            } else {
                showSnackbar({
                    text: this.$localize('ApiKey.message.couldNotCopy'),
                })
            }
        },
        onInput(event) {
            this.reset()
            this.$emit('input', event)
        },
    },
}
</script>
